import Button from '../ui/Button';

function PendingApprovalPage({ email, onSignOut }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-10">
      <div className="flex w-full max-w-md flex-col items-center gap-6 text-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Family Growers</h1>
          <p className="mt-1 text-sm text-gray-500">App de Campo</p>
        </div>

        <div className="w-full rounded-2xl border border-amber-200 bg-amber-50 p-6">
          <p className="font-medium text-amber-800">Solicitud enviada</p>
          <p className="mt-3 text-sm text-amber-700">
            Tu cuenta está pendiente de aprobación. Un administrador debe validar tu solicitud y asignarte el
            productor correspondiente.
          </p>

          <div className="mt-4 flex flex-col gap-1 border-t border-amber-200 pt-4 text-left text-sm text-amber-800">
            <p>
              <span className="font-medium">Estado:</span> Pendiente de aprobación
            </p>
            {email && (
              <p>
                <span className="font-medium">Correo:</span> {email}
              </p>
            )}
          </div>
        </div>

        <Button variant="secondary" className="max-w-xs" onClick={onSignOut}>
          Cerrar sesión
        </Button>
      </div>
    </div>
  );
}

export default PendingApprovalPage;
